import { Button } from '@mui/material';

export function XButton(props: any) {
  return (
    <Button
      variant={props.variant}
      color={props.color}
      onClick={() => props.onClick?.()}
      size={props.size}
      disabled={props.disabled}
      sx={{
        ...props.sx,
        padding: "4px",
        whiteSpace: "nowrap",
      }}
    >
      {props.children}
      {props.label}
    </Button>
  );
}
